import React from 'react';

import Icon from './components/Icon';

const IconVolumeOn = (props: any) => {
	return <Icon id="sti-volume-on" handle={props.handle} {...props} />;
};

export default IconVolumeOn;
